var fuseSettingsConfig = {
    layout: {
        style: 'layout1',
        config: {
            scroll: 'content',
            navbar: {
                display: false,
                folded: false,
                position: 'left',
            },
            toolbar: {
                display: true,
                style: 'fixed',
                position: 'below',
            },
            footer: {
                display: false,
                style: 'fixed',
                position: 'below',
            },
            mode: 'fullwidth',
        },
    },
    customScrollbars: true,
    theme: {
        main: 'default',
        navbar: 'mainThemeDark',
        toolbar: 'mainThemeLight',
        footer: 'mainThemeDark',
    },
};
export default fuseSettingsConfig;



//////////////////
// WEBPACK FOOTER
// ./src/fuse-configs/fuseSettingsConfig.ts
// module id = 1168
// module chunks = 81